import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class DateHelperService {
  constructor(private datePipe: DatePipe) {}

  formatDate(date: Date, format: string): string {
    return this.datePipe.transform(date, format) || '';
  }
}